import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import styles from './SettingsPage.module.css';

type Status = { success: boolean; data: {
  model_behavior: Array<{ _id: string; vendor: string; charger_model: string; finishing_seen?: boolean;
    available_seen?: boolean; missing_timestamp_count: number; no_removal_count: number }>;
} };
export function IdleModelSection() {
  const query = useQuery({ queryKey: ['idle-models'], queryFn: () => api.get('settings/idle-models').json<Status>() });
  return <section className={styles.card}>
    <h2 className={styles.cardTitle}>Reported cable behavior by model</h2>
    <p className={styles.cardLead}>Idle fees use timestamped charger reports until the cable is removed. Notifications are best-effort and do not affect saving an idle fee.</p>
    {query.isError && <p role="alert">Unable to load model evidence.</p>}
    <div className={styles.taxTableWrap}><table className={styles.taxTable}>
      <thead><tr><th>Model</th><th>Finishing</th><th>Available</th><th>Missing timestamp reports</th><th>Missing removal sessions</th></tr></thead>
      <tbody>{query.data?.data.model_behavior.map(m => <tr key={m._id}><td>{m.vendor} {m.charger_model}</td>
        <td>{m.finishing_seen ? 'Observed' : 'Not observed'}</td><td>{m.available_seen ? 'Observed' : 'Not observed'}</td>
        <td>{m.missing_timestamp_count}</td><td>{m.no_removal_count}</td></tr>)}</tbody>
    </table></div>
    {!query.data?.data.model_behavior.length && <p>No new model evidence recorded yet. Runtime reports verify each model separately.</p>}
  </section>;
}
